export enum RequesterTypology {
  Tenant = 'tenant',
  Landlord = 'landlord',
  PotentialTenant = 'p_tenant',
  PotentialLandlord = 'p_landlord',
}
